export type Language = 'sk' | 'en';

/** Slovak is the default and the fallback for every key (BRIEF A-16). */
export const DEFAULT_LANGUAGE: Language = 'sk';

export const LANGUAGE_STORAGE_KEY = 'stock.bo.language';

export const LANGUAGES: Array<Language> = ['sk', 'en'];
